import React, { useEffect, useState } from "react";
import AddIcon from "@material-ui/icons/Add";
import { useSnackbar } from "notistack";
import Fab from "@material-ui/core/Fab";
import { makeStyles } from "@material-ui/core/styles";
import Table from "../../Table";
import { useTranslation } from "react-multi-lang";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { companiesService } from "../../../utils/feathers";

const useStyles = makeStyles((theme) => ({
  fab: {
    margin: theme.spacing(1),
    right: 10,
    bottom: 10,
    left: "auto",
    position: "fixed",
  },
}));

function Companies() {
  const classes = useStyles();
  const history = useHistory();
  const t = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [isLoading, setIsLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [filters, setFilters] = useState({
    skip: 0,
    limit: 50,
    sort: { CompanyId: -1 },
    query: {},
  });

  const changeFilters = ({ skip, query, sort }) => {
    setFilters((prev) => ({ ...prev, skip, query, sort }));
  };

  const errorMessage = t("common.error");

  useEffect(() => {
    async function fetchData() {
      try {
        const data = await companiesService.find({
          query: {
            $limit: filters.limit,
            $skip: filters.skip,
            $or: filters.query,
            $sort: filters.sort,
          },
        });

        setTotal(data.total);
        setRows(data.data);
      } catch (e) {
        enqueueSnackbar(errorMessage, { variant: "error" });
      }

      setIsLoading(false);
    }

    fetchData();
  }, [filters, errorMessage, enqueueSnackbar]);

  const onDelete = async (id) => {
    await companiesService.remove(id);
  };

  const title = t("companies.title");

  return (
    <div>
      <Helmet>
        <title>Attis - {title}</title>
      </Helmet>
      <Table
        title={title}
        path="companies"
        idColumn="CompanyId"
        tableColumns={[
          { title: t("companies.id"), name: "CompanyId" },
          { title: t("companies.codeDGS"), name: "CodeDGS" },
          { title: t("companies.companyName"), name: "CompanyName" },

          {
            title: t("companies.cif"),
            name: "CompanyCIF",
          },
        ]}
        tableRows={rows}
        totalRows={total}
        changeFilters={changeFilters}
        onDelete={onDelete}
        isLoading={isLoading}
      />
      <Fab
        color="primary"
        aria-label={t("common.new")}
        onClick={() => {
          history.push("/companies/new");
        }}
        className={classes.fab}
      >
        <AddIcon />
      </Fab>
    </div>
  );
}

export default Companies;
